import { render, staticRenderFns } from "./groupBuying.vue?vue&type=template&id=0715729a&scoped=true"
import script from "./groupBuying.vue?vue&type=script&lang=js"
export * from "./groupBuying.vue?vue&type=script&lang=js"
import style0 from "./groupBuying.vue?vue&type=style&index=0&id=0715729a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0715729a",
  null
  
)

export default component.exports